/**
 * Created by Fernando Torres on 18/04/2018.
 */
import BaseStore from '../base-store'

let options = {}
export default new BaseStore('branch-division-scores', options)



// WEBPACK FOOTER //
// ./src/store/branch-division-scores/index.js